var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import id from "@irati/utils/id";
import { DropdownMenu } from "./styled/DropdownOverlay";
var DropdownOverlay = /** @class */ (function (_super) {
    __extends(DropdownOverlay, _super);
    function DropdownOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false
        };
        _this.node = React.createRef();
        _this.handleOutsideClick = function (e) {
            var defaultFalse = { contains: function () { return false; } };
            var node = _this.node.current || defaultFalse;
            var toggle = _this.props.toggleRef.current || defaultFalse;
            if (!node.contains(e.target) && !toggle.contains(e.target)) {
                _this.props.onClickOutside();
            }
        };
        return _this;
    }
    DropdownOverlay.prototype.componentDidMount = function () {
        document.addEventListener("mousedown", this.handleOutsideClick, false);
    };
    DropdownOverlay.prototype.componentWillUnmount = function () {
        document.removeEventListener("mousedown", this.handleOutsideClick, false);
    };
    DropdownOverlay.prototype.render = function () {
        var _a = this.props, children = _a.children, width = _a.width;
        var idNamespace = id("dropdown", this.props);
        return (React.createElement(DropdownMenu, { ref: this.node, id: idNamespace, width: width }, children));
    };
    DropdownOverlay.defaultProps = {
        toggleRef: {},
        onClickOutside: function () { return null; }
    };
    return DropdownOverlay;
}(PureComponent));
export default DropdownOverlay;
